// --- Configuration ---
// This object holds configuration settings for the app.
// The BASE_URL should be updated with the API Gateway endpoint after deployment.
const config = {
  // IMPORTANT: Replace this with your actual API Gateway endpoint URL from the CloudFormation outputs.
  DATA_API_URL: 'https://85l0siz7t8.execute-api.eu-central-1.amazonaws.com'
};

// --- API Helper ---
async function callApi(baseUrl, endpoint, method = 'GET', body = null) {
  if (baseUrl.includes('YOUR_API_GATEWAY_URL_HERE')) {
    return { success: false, error: `API Gateway URL not configured.` };
  }
  const apiUrl = `${baseUrl}${endpoint}`;
  const options = { method, headers: { 'Content-Type': 'application/json' } };
  if (body) options.body = JSON.stringify(body);

  try {
    const response = await fetch(apiUrl, options);
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result.error || `Request failed: ${response.status}`);
    return { success: true, data: result };
  } catch (error) {
    return { success: false, error: error.message };
  }
}

export { config, callApi };